module.exports = __webpack_public_path__ + "static/shopping-retail-c76cda5d6252c7bc267084191e2da2f5.jpg";